"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRegistrationFile = exports.preUploadRegistrationFileDnD = exports.uploadRegistrationFileDnD = exports.preUploadRegistrationFileButton = exports.uploadRegistrationFileButton = exports.getRegistrationFile = exports.enableUploadButtonNotesCheckboxState = void 0;
const axios_1 = require("~modules/axios");
const endpointUrlBases = {
    student: `${laravel.url}/api/work-registrations/students`,
    school: `${laravel.url}/api/work-registrations/schools`,
    "applicant-list": `${laravel.url}/api/applicant-list-registrations/schools`,
};
const dragOverClassName = "is-dragover";
/**
 * 注意事項のチェックボックスの状態によってアップロードボタンを有効／無効化する
 *
 * @returns {void}
 */
const enableUploadButtonNotesCheckboxState = () => {
    const notesCheckedCheckboxes = document.querySelectorAll(".js-notes-checked");
    if (!notesCheckedCheckboxes) {
        return;
    }
    enableButton(notesCheckedCheckboxes);
    notesCheckedCheckboxes.forEach((element) => {
        element.addEventListener("change", (e) => {
            enableButton(notesCheckedCheckboxes);
        });
    });
};
exports.enableUploadButtonNotesCheckboxState = enableUploadButtonNotesCheckboxState;
/**
 * ファイル情報を取得する
 *
 * @returns {void}
 */
const getRegistrationFile = () => {
    const uploadFileNameElement = document.querySelector(".js-upload-filename");
    if (!uploadFileNameElement) {
        return;
    }
    const uploadTarget = uploadFileNameElement.dataset.uploadTarget;
    if (!uploadTarget || !endpointUrlBases.hasOwnProperty(uploadTarget)) {
        return;
    }
    axios_1.appAxios
        .get(endpointUrlBases[uploadTarget])
        .then((response) => {
        // ファイル名を表示する
        displayFileName(response.data);
    })
        .catch((errors) => {
        (0, axios_1.responseFetchError)(errors);
    });
};
exports.getRegistrationFile = getRegistrationFile;
/**
 * ファイル検証の進捗状況を監視する
 *
 * @param {string} token
 * @param {number} duration  Default: 1800000（30分）
 * @param {number} interval  Default: 3000（3秒）
 * @returns {void}
 */
const validateProgressFetch = (token, duration = 1800000, interval = 3000) => {
    const start = Date.now();
    const intervalId = setInterval(() => {
        if (Date.now() - start >= duration) {
            clearInterval(intervalId);
            return;
        }
        axios_1.appAxios
            .post(`${laravel.url}/api/work-registrations/validate-progress`, {
            token: token,
        })
            .then((response) => {
            if (response.data.meta.remaining === 0 && response.data.data) {
                // ファイル名を表示する
                displayFileName({
                    data: response.data.data,
                    meta: {
                        number_of_uploaded: response.data.meta.number_of_uploaded,
                    },
                });
                displayLoader(true);
                clearInterval(intervalId);
            }
        })
            .catch((errors) => {
            (0, axios_1.responseFileUploadError)(errors);
            displayLoader();
            clearInterval(intervalId);
        });
    }, interval);
};
/**
 * イベント発生元の要素の値をクリアする
 *
 * @param {MouseEvent} e
 * @returns {void}
 */
const handleCurrentValueClear = (e) => {
    if (!(e.currentTarget instanceof HTMLInputElement)) {
        return;
    }
    e.currentTarget.value = "";
};
/**
 * アップロードボタンでファイルをアップロードする
 *
 * @returns {void}
 */
const uploadRegistrationFileButton = () => {
    const uploadFileElement = document.querySelector(".js-upload-file");
    if (!uploadFileElement) {
        return;
    }
    // 削除後に同じファイルを選択された場合に change イベントが発火しないため
    // click イベントで選択済みのファイル情報をクリアする
    uploadFileElement.addEventListener("click", handleCurrentValueClear);
    uploadFileElement.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement)) {
            return;
        }
        const uploadTarget = e.currentTarget.dataset.uploadTarget;
        if (!uploadTarget || !endpointUrlBases.hasOwnProperty(uploadTarget)) {
            return;
        }
        const fileList = e.currentTarget.files;
        if (fileList === null || fileList.length === 0) {
            return;
        }
        const formData = new FormData();
        for (const file of fileList) {
            formData.append(`${laravel.uploadFieldName}[]`, file);
        }
        displayLoader(false);
        axios_1.appAxios
            .post(`${endpointUrlBases[uploadTarget]}/upload`, formData)
            .then((response) => {
            // ファイル名を表示する
            displayFileName(response.data);
            displayLoader(true);
        })
            .catch((errors) => {
            (0, axios_1.responseFileUploadError)(errors);
            displayLoader();
        });
    });
};
exports.uploadRegistrationFileButton = uploadRegistrationFileButton;
/**
 * アップロードボタンでファイルをアップロードする（ファイル検証の進捗あり）
 *
 * @returns {void}
 */
const preUploadRegistrationFileButton = () => {
    const uploadFileElement = document.querySelector(".js-pre-upload-file");
    if (!uploadFileElement) {
        return;
    }
    // 削除後に同じファイルを選択された場合に change イベントが発火しないため
    // click イベントで選択済みのファイル情報をクリアする
    uploadFileElement.addEventListener("click", handleCurrentValueClear);
    uploadFileElement.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement)) {
            return;
        }
        const uploadTarget = e.currentTarget.dataset.uploadTarget;
        if (!uploadTarget || !endpointUrlBases.hasOwnProperty(uploadTarget)) {
            return;
        }
        const fileList = e.currentTarget.files;
        if (fileList === null || fileList.length === 0) {
            return;
        }
        const formData = new FormData();
        for (const file of fileList) {
            formData.append(`${laravel.uploadFieldName}[]`, file);
        }
        displayLoader(false);
        axios_1.appAxios
            .post(`${endpointUrlBases[uploadTarget]}/upload`, formData)
            .then((response) => {
            validateProgressFetch(response.data.token);
        })
            .catch((errors) => {
            (0, axios_1.responseFileUploadError)(errors);
            displayLoader();
        });
    });
};
exports.preUploadRegistrationFileButton = preUploadRegistrationFileButton;
/**
 * dragover イベントハンドラ
 *
 * @param {MouseEvent} e
 * @returns {void}
 */
const handleDragOver = (e) => {
    e.preventDefault();
    if (!(e.currentTarget instanceof HTMLElement)) {
        return;
    }
    e.currentTarget.classList.add(dragOverClassName);
};
/**
 * dragleave イベントハンドラ
 *
 * @param {MouseEvent} e
 * @returns {void}
 */
const handleDragLeave = (e) => {
    e.preventDefault();
    if (!(e.currentTarget instanceof HTMLElement)) {
        return;
    }
    e.currentTarget.classList.remove(dragOverClassName);
};
/**
 * dragenter イベントハンドラ
 *
 * @param {MouseEvent} e
 * @returns {void}
 */
const handleDragEnter = (e) => {
    e.preventDefault();
    if (!(e.currentTarget instanceof HTMLElement)) {
        return;
    }
    e.currentTarget.classList.remove(dragOverClassName);
};
/**
 * ドラッグ & ドロップでファイルをアップロードする
 *
 * @returns {void}
 */
const uploadRegistrationFileDnD = () => {
    const uploadFileDropareaElement = document.querySelector(".js-upload-file-droparea");
    const notesCheckedCheckboxes = document.querySelectorAll(".js-notes-checked");
    if (!uploadFileDropareaElement) {
        return;
    }
    const uploadTarget = uploadFileDropareaElement.dataset.uploadTarget;
    if (!uploadTarget || !endpointUrlBases.hasOwnProperty(uploadTarget)) {
        return;
    }
    // ドロップエリア内にある時
    uploadFileDropareaElement.addEventListener("dragover", handleDragOver);
    // ドロップエリア内から離れた時
    uploadFileDropareaElement.addEventListener("dragleave", handleDragLeave);
    // ドラッグが終了した時
    uploadFileDropareaElement.addEventListener("dragenter", handleDragEnter);
    // ドロップされた時
    uploadFileDropareaElement.addEventListener("drop", (e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
            e.currentTarget.classList.remove(dragOverClassName);
        }
        if (notesCheckedCheckboxes.length > 0) {
            let checkedNum = 0;
            notesCheckedCheckboxes.forEach((element) => {
                if (element.checked) {
                    checkedNum++;
                }
            });
            if (notesCheckedCheckboxes.length !== checkedNum) {
                alert("「著作権等に関する注意事項」をご確認ください。");
                return;
            }
        }
        const fileList = e.dataTransfer?.files;
        if (!fileList) {
            return;
        }
        const formData = new FormData();
        for (const file of fileList) {
            formData.append(`${laravel.uploadFieldName}[]`, file);
        }
        displayLoader(false);
        axios_1.appAxios
            .post(`${endpointUrlBases[uploadTarget]}/upload`, formData)
            .then((response) => {
            // ファイル名を表示する
            displayFileName(response.data);
            displayLoader(true);
        })
            .catch((errors) => {
            (0, axios_1.responseFileUploadError)(errors);
            displayLoader();
        });
    });
};
exports.uploadRegistrationFileDnD = uploadRegistrationFileDnD;
/**
 * ドラッグ & ドロップでファイルをアップロードする（ファイル検証の進捗あり）
 *
 * @returns {void}
 */
const preUploadRegistrationFileDnD = () => {
    const uploadFileDropareaElement = document.querySelector(".js-pre-upload-file-droparea");
    const notesCheckedCheckboxes = document.querySelectorAll(".js-notes-checked");
    if (!uploadFileDropareaElement) {
        return;
    }
    const uploadTarget = uploadFileDropareaElement.dataset.uploadTarget;
    if (!uploadTarget || !endpointUrlBases.hasOwnProperty(uploadTarget)) {
        return;
    }
    // ドロップエリア内にある時
    uploadFileDropareaElement.addEventListener("dragover", handleDragOver);
    // ドロップエリア内から離れた時
    uploadFileDropareaElement.addEventListener("dragleave", handleDragLeave);
    // ドラッグが終了した時
    uploadFileDropareaElement.addEventListener("dragenter", handleDragEnter);
    // ドロップされた時
    uploadFileDropareaElement.addEventListener("drop", (e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
            e.currentTarget.classList.remove(dragOverClassName);
        }
        if (notesCheckedCheckboxes.length > 0) {
            let checkedNum = 0;
            notesCheckedCheckboxes.forEach((element) => {
                if (element.checked) {
                    checkedNum++;
                }
            });
            if (notesCheckedCheckboxes.length !== checkedNum) {
                alert("「著作権等に関する注意事項」をご確認ください。");
                return;
            }
        }
        const fileList = e.dataTransfer?.files;
        if (!fileList) {
            return;
        }
        const formData = new FormData();
        for (const file of fileList) {
            formData.append(`${laravel.uploadFieldName}[]`, file);
        }
        displayLoader(false);
        axios_1.appAxios
            .post(`${endpointUrlBases[uploadTarget]}/upload`, formData)
            .then((response) => {
            validateProgressFetch(response.data.token);
        })
            .catch((errors) => {
            (0, axios_1.responseFileUploadError)(errors);
            displayLoader();
        });
    });
};
exports.preUploadRegistrationFileDnD = preUploadRegistrationFileDnD;
/**
 * ファイルを削除する
 *
 * @return {void}
 */
const deleteRegistrationFile = () => {
    const uploadFileNameElement = document.querySelector(".js-upload-filename");
    if (!uploadFileNameElement) {
        return;
    }
    const uploadTarget = uploadFileNameElement.dataset.uploadTarget;
    if (!uploadTarget || !endpointUrlBases.hasOwnProperty(uploadTarget)) {
        return;
    }
    // 削除
    uploadFileNameElement.addEventListener("click", (e) => {
        if (!(e.target instanceof HTMLElement) ||
            !e.target.classList.contains("js-upload-file-delete")) {
            return;
        }
        const fileNames = Array.from(uploadFileNameElement.children);
        const index = fileNames.findIndex((fileName) => {
            if (!(e.target instanceof HTMLElement)) {
                return;
            }
            return fileName === e.target.closest(".editname");
        });
        axios_1.appAxios
            .delete(`${endpointUrlBases[uploadTarget]}/${index}`)
            .then((response) => {
            // ファイル名を表示する
            displayFileName(response.data);
        })
            .catch((errors) => {
            (0, axios_1.responseFetchError)(errors);
        });
    });
};
exports.deleteRegistrationFile = deleteRegistrationFile;
/**
 * ボタンを有効／無効化する
 *
 * @param {NodeListOf<HTMLInputElement>} checkboxes
 * @returns {void}
 */
const enableButton = (checkboxes) => {
    const uploadButton = document.querySelector(".js-upload-file-button");
    if (!uploadButton) {
        return;
    }
    let checkedNum = 0;
    checkboxes.forEach((element) => {
        if (element.checked) {
            checkedNum++;
        }
    });
    const formControlls = uploadButton.querySelectorAll("input, select, textarea, button");
    if (checkboxes.length === checkedNum) {
        uploadButton.classList.remove("is-disabled");
        formControlls.forEach((element) => {
            element.disabled = false;
        });
    }
    else {
        uploadButton.classList.add("is-disabled");
        formControlls.forEach((element) => {
            element.disabled = true;
        });
    }
};
/**
 * ファイル名を表示する
 *
 * @param {UploadFileJsonType} uploadFile
 * @returns {void}
 */
const displayFileName = (uploadFile) => {
    const uploadFileNameElement = document.querySelector(".js-upload-filename");
    if (!uploadFileNameElement) {
        return;
    }
    uploadFileNameElement.innerHTML = "";
    if (uploadFile.data.length > 0) {
        for (let i = 0; i < uploadFile.data.length; i++) {
            uploadFileNameElement.insertAdjacentHTML("beforeend", `<p class="editname"><span>${uploadFile.data[i].name}</span><i class="fa-sharp fa-solid fa-xmark delete-icon js-upload-file-delete"></i></p>`);
        }
    }
    else {
        uploadFileNameElement.innerHTML = "<p>選択されていません</p>";
    }
    const numberOfUploadedFilesElement = document.querySelector(".js-number-of-uploaded-files");
    if (numberOfUploadedFilesElement) {
        numberOfUploadedFilesElement.textContent =
            uploadFile.meta.number_of_uploaded.toString();
    }
};
/**
 * ローダーを表示する
 *
 * @param {boolean|null} isCompletion Default: null
 * @returns {void}
 */
const displayLoader = (isCompletion = null) => {
    const loaderElement = document.querySelector(".js-loader");
    if (!loaderElement) {
        return;
    }
    loaderElement.innerHTML = "";
    if (isCompletion === true) {
        loaderElement.innerHTML = `<div class="p-loader"><div class="p-loader__completion-label">アップロード完了</div>`;
    }
    else if (isCompletion === false) {
        loaderElement.innerHTML = `<div class="c-loader p-loader"><div class="c-loader__spinner"></div><div class="c-loader__label p-loader__label">アップロード中です。しばらくお待ち下さい。</div></div>`;
    }
};
